export default "__VITE_ASSET__CeKMA7OK__"